// extracted by mini-css-extract-plugin
module.exports = {"root":"Portal-module__root___3oj4d","parent":"Portal-module__parent___Oennu"};